import {
    GET_ALL_EXHIBITORS,
    SET_ALL_EXHIBITORS
} from '../actions/ExhibitorActions'

import { persistReducer } from 'redux-persist';
import storage from 'localforage';

const persistConfig = {
    key: 'exhibitor',
    storage,
};


const initialState = {
    data: [],
    totalScanned: 0,
    latestUpdate: '',
    loading: false,
    error: '',
}

const ExhibitorReducer = function (state = initialState, action) {
    switch (action.type) {
        case "GET_ALL_EXHIBITORS": {
            return {
                ...state,
                data: action.payload.data.exhibitors,
                totalScanned: action.payload.data.totalScanned,
            }
        }
        case "SET_ALL_EXHIBITORS": {
            console.log(action.payload)
            return {
                ...state,
                data: action.payload.exhibitors,
                totalScanned: action.payload.totalScanned,
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default persistReducer(persistConfig, ExhibitorReducer);

